import { render, staticRenderFns } from "./common-company.vue?vue&type=template&id=6a60f597&scoped=true"
import script from "./common-company.vue?vue&type=script&lang=js"
export * from "./common-company.vue?vue&type=script&lang=js"
import style0 from "./common-company.vue?vue&type=style&index=0&id=6a60f597&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a60f597",
  null
  
)

export default component.exports